module.exports = __webpack_public_path__ + "static/media/cost.238cd010.svg";